const dev = {
    apiUrl: "http://localhost:3005/api/",
    qtUrl: "http://localhost:5003/api/",
    dpvUrl: 'http://localhost:6080/api/',
    decorURL: 'https://decorassisterp.decorpot.com/api/',
    deliveryUrl: 'https://ftt.decorpot.com/api/',
    metaUrl: 'https://quotationerp.decorpot.com/',
}

const test = {
    apiUrl: "http://11.0.128.71:3005/api/",
    qtUrl: "http:///11.0.128.71:5003/api/",
    decorURL: 'https://decorassisterp.decorpot.com/api/',
    deliveryUrl: 'https://ftt.decorpot.com/api/',
    metaUrl: 'https://quotationerp.decorpot.com/',
}

// const prod = {
//     apiUrl: "http://13.233.26.162:3005/api/",
//     qtUrl: "http:///13.233.26.162:5003/api/"
// }

const prod = {
    apiUrl: "https://inventoryerp.decorpot.com/api/",
    qtUrl: "https://quotationerp.decorpot.com/api/",
    dpvUrl: 'https://decorpayerp.decorpot.com/api/',
    decorURL: 'https://decorassisterp.decorpot.com/api/',
    deliveryUrl: 'https://ftt.decorpot.com/api/',
    metaUrl: 'https://quotationerp.decorpot.com/',
}

const config =
    process.env.REACT_APP_STAGE === "production"
        ? prod :
        process.env.REACT_APP_STAGE === "test"
            ? test
            : dev; 
export default config;
